// /client/src/components/FooterPdfs.js
import React from 'react';

const FooterPdfs = () => {
    return (
        <>
            <style>{`
                @media screen and (max-width: 768px) {
                .pdf-page-footer a {
                    display: block;
                }
                }
            `}</style>
            <footer className="columns is-centered fullWidth pdf-page-footer">
                <div className="is-size-7">
                    © 2026 Next Move Network
                    <a href="https://www.nextmovenetwork.com/contact" className="is-size-7" target="_blank" rel="noopener noreferrer">Contact</a>
                    <a href="https://www.nextmovenetwork.com/privacy-policy" className="is-size-7" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    <a href="https://www.nextmovenetwork.com/terms-of-service" className="is-size-7" target="_blank" rel="noopener noreferrer">Terms of Use</a>
                    <a href="https://www.nextmovenetwork.com/copy-of-terms-of-use" className="is-size-7" target="_blank" rel="noopener noreferrer">Accessibility Statement</a>
                </div>
            </footer>
        </>
    );
}

export default FooterPdfs;